module.exports = __webpack_public_path__ + "img/blueprint2.2fffddfb.jpg";